import { Input, HStack } from "@chakra-ui/react";
import { useState } from "react";

const TimeInput = ({ label, value, onChange }) => {
    const [time, setTime] = useState(convertSecondsToTime(value));

    const formatTimeInput = (value) => {
        // Remove all non-numeric characters except `.` and `:`
        let cleaned = value.replace(/[^0-9:.]/g, "");

        // Enforce max length (12 characters: "HH:MM:SS.MS")
        if (cleaned.length > 12) {
            cleaned = cleaned.substring(0, 12);
        }

        // Add formatting automatically
        let formatted = cleaned
            .replace(/^(\d{2})(\d)/, "$1:$2") // Insert first colon
            .replace(/^(\d{2}:\d{2})(\d)/, "$1:$2") // Insert second colon
            .replace(/^(\d{2}:\d{2}:\d{2})(\d)/, "$1.$2"); // Insert dot

        return formatted;
    };

    const handleInputChange = (e) => {
        let value = formatTimeInput(e.target.value);
        setTime(value);

        const seconds = convertTimeToSeconds(value);
        if (!isNaN(seconds)) {
            onChange(seconds);
        }
    };

    return (
        <Input
            value={time}
            onChange={handleInputChange}
            placeholder="HH:MM:SS.MS"
            maxLength={12}
        />
    );
};

// Convert seconds to "HH:MM:SS.MS"
const convertSecondsToTime = (seconds) => {
    if (!seconds) return "00:00:00.000";
    const hrs = Math.floor(seconds / 3600).toString().padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
    const secs = Math.floor(seconds % 60).toString().padStart(2, "0");
    const ms = ((seconds % 1) * 1000).toFixed(0).padStart(3, "0");
    return `${hrs}:${mins}:${secs}.${ms}`;
};

// Convert "HH:MM:SS.MS" to seconds
const convertTimeToSeconds = (time) => {
    const [hms, ms] = time.split(".");
    const [hrs, mins, secs] = hms.split(":").map(Number);
    return (hrs || 0) * 3600 + (mins || 0) * 60 + (secs || 0) + (parseInt(ms) / 1000 || 0);
};

export default TimeInput;
